import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { EditorMode, NotifierEvents, ReferenceType } from 'src/app/common/enums/enums';
import { CustomError } from "src/app/common/helpers/custom-error";
import { DateHelper } from "src/app/common/helpers/date-helper";
import { GuidGenerator } from 'src/app/common/helpers/guid-generator';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { ParentMessageType } from 'src/app/common/models/ParentMessage';
import { ResponseModel } from "src/app/common/models/ResponseModel";
import { EventApiService } from "src/app/services/API/event-api.service";
import { HistoryService } from 'src/app/services/history.service';
import { ParentCommunicatorService } from 'src/app/services/parent-communicator.service';
import { PreferencesService } from "src/app/services/preferences.service";
import { LoadingService } from 'src/app/services/UI/loading.service';
import { ComponentBase } from "../../base/component-base";
import { MessageDialogService } from '../../message-dialog/services/message-dialog.service';
import { DialogService } from 'src/app/services/UI/dialog.service';
import { EventViewBase } from '../models/event-view-base';

@Component({
    selector: "app-events-main",
    templateUrl: "./events-main.component.html",
    styleUrls: ["./events-main.component.scss"],
    standalone: false
})
export class EventsMainComponent extends ComponentBase implements OnInit, OnDestroy{

  @Input() data: any;
  @Input() title: any;
  eventConfig:any;
  @Output() changeData = new EventEmitter();
  expectedUpdates = [ NotifierEvents.RootMemberUpdated,
                      NotifierEvents.RootFamilyUpdated,
                      NotifierEvents.RootFamilyChanged];
  timeStamp: any;

  eventList: EventViewBase[];
  viewMode: number = 1;

  //Dirty check
  isDirty: boolean = false;
  isLoading: boolean = false;

  constructor(
    private eventApiService : EventApiService,
    private historyService : HistoryService,
    private changeDetectorRef: ChangeDetectorRef,
    private preferenceService: PreferencesService, private loadingService: LoadingService,
    private parentCommunicatorService: ParentCommunicatorService, private translateHandler : TranslateHandler,
    private dialogService : MessageDialogService,
    private readonly churchBookDialogService: DialogService,
  ) {
    super();
    this.eventList = new Array<EventViewBase>();
  }

  public canChange(): boolean {
    return !this.data.isEventDirty;
  }

  ngOnInit(): void {
    this.getViewMode();
  }

  async ngOnChanges(changes: SimpleChanges) {
    let change = changes['data'];
    if (change && !change.firstChange) {
      if (change.previousValue != change.currentValue) {
        this.changeViewMode(1);
      }
    }


   if (change && (change.firstChange || change.previousValue !== change.currentValue)) {
    if (this.data && this.data.id) {
      const referenceType = (this.data.editorMode == EditorMode.IndividualEditor)
        ? ReferenceType.Individual
        : (this.data.editorMode == EditorMode.FamilyEditor)
          ? ReferenceType.Family
          : ReferenceType.None;

      await this.fillEventList(this.data.id, referenceType);

      this.eventConfig = {
        message: this.translateHandler.translate('err_no_event_for_resource', [
          this.translateHandler.translate(referenceType === 1 ? 'lbl_person' : 'lbl_family').toLowerCase()
        ]),
        referenceType: referenceType
      };
    }
  }
  }

  getViewMode(): number {
    return this.viewMode;
  }

  changeViewMode(mode) {
    this.data.isEventDirty = false;
    if (mode == 2) {
      if(this.data.id === 0) {
        this.dialogService.openWarn(this.translateHandler.translate('lbl_info'),this.translateHandler.translate('inf_save_family_before_add_event'),'');
      }
      else {
        this.viewMode = mode;
        this.data.eventId = 0;
      }
    }
    else
      this.viewMode = mode;
  }

  async refreshEventList(mode) {
    this.viewMode = mode;
    var referenceType = (this.data.editorMode == EditorMode.IndividualEditor) ? ReferenceType.Individual : ReferenceType.Family;
    var lastUser = this.historyService.individualList[this.historyService.individualList.length - 1];

    await this.fillEventList(parseInt(lastUser.Id), referenceType);
    this.changeData.emit(this.data);

  }

  openEditorView(event) {
    this.viewMode = 2;
    this.data.eventId = event.id;
    this.data.isCustomEvent = event.isCustomEvent;
    this.changeDetectorRef.detectChanges();
  }

  async fillEventList(referanceId: number, referenceType: number): Promise<void> {
  this.timeStamp = performance.now();
  const processId = GuidGenerator.generate();
  this.loadingService.show(processId);

  try {
    const response = await this.eventApiService
      .getEvents(referanceId, referenceType)
      .toPromise() as ResponseModel<EventViewBase[]>;
       this.loadingService.hide(processId);

    // Process and assign
    this.eventList = this.orderEventList(response.data);

  } catch (err) {
    throw new CustomError("EventMain => fillEventList() : " + err, 911, false);
  } finally {
    this.loadingService.hide(processId);
  }
}

  orderEventList(eventArray) {
    let dateHelper = new DateHelper(this.preferenceService);
    if (eventArray && eventArray.length > 0) {
      eventArray.forEach(event => {
        if (event?.date) {
          if(event.date.genealogyDate != null){
            event.date = dateHelper.validateAndFormat(event.date.genealogyDate.originalStr);
            if (event?.date?.isValidDate && event?.date?.genealogyDate) {
              event.date.mappedDate = dateHelper.mapToDate(event.date.genealogyDate.year, event.date.genealogyDate.month, event.date.genealogyDate.day)
            } else if (event?.date?.genealogyDate?.originalStr) {
              event.date.invalidMappedDate = event.date.genealogyDate.originalStr;
            }
            else
              event.date.mappedDate = "";
          }
        }
      });
      eventArray.sort((n1, n2) => {
        if (!n1.date || n1.date.mappedDate == "") return -1;
        if (!n2.date || n2.date.mappedDate == "") return 0;
        if (!n1.date || n1.date.invalidMappedDate) return -1;
        if (!n2.date || n2.date.invalidMappedDate) return 0;

        if (n1.date.mappedDate > n2.date.mappedDate) {
          return 1;
        }
        if (n1.date.mappedDate < n2.date.mappedDate) {
          return -1;
        }
        return 0;
      });
      return eventArray;
    }
  }

  browseEvents(): void {
    this.churchBookDialogService.setHalf().open('ChurchBookBrowse', { searchType: 'event' });
  }

  showNotImplemented() {
    this.parentCommunicatorService.send(ParentMessageType.ShowInformation, "not_implemented");
  }


  notify() {
    this.refreshEventList(1);
  }
}

